module.exports = __webpack_public_path__ + "img/plant_1_mobile.d6f23734.webp";